export const toMinutes = () => value => Math.round(value / 60);



// WEBPACK FOOTER //
// ./src/filters/toMinutes.js